import EventBus from "eventing-bus"
import { constants, getCurrSection } from "../model"

const viewEl = document.querySelector("#product-nav-view")

const handleSectionChanged = () => {
  viewEl.classList.remove("show")

  setTimeout(() => {
    viewEl.classList = ""
    if (getCurrSection() < 3) viewEl.classList.add("show")
    switch (getCurrSection()) {
      case 0:
        viewEl.classList.add("section0")
        break
      case 1:
        viewEl.classList.add("section1")
        break
      case 2:
        viewEl.classList.add("section2")
        break
    }
  }, 2000)
}

EventBus.on(constants.SECTION_CHANGED, handleSectionChanged)
